import { z } from 'zod';

/**
 * An enum that must be present, reporting `message` only when it is MISSING.
 *
 * `z.enum(values, message)` uses the one message for every failure, so a value
 * left out and a value outside the set both read "… is required" — which is
 * wrong, and unhelpful, for the second. yup kept them apart: `.required(msg)`
 * carried the custom message and `.oneOf()` listed what was allowed. This does
 * the same, so a caller is told which of the two they did.
 */
export const requiredEnum = <T extends Record<string, string>>(
  values: T,
  message: string,
) =>
  z.enum(values, {
    error: (issue) =>
      issue.input === undefined
        ? message
        : `must be one of the following values: ${Object.values(values).join(
            ', ',
          )}`,
  });
